const SET_CASINO_ID = 'set_casino_id'

export default {
  namespaced: true,
  state: {
    selectedCasinoId: null
  },
  mutations: {
    [SET_CASINO_ID] (state, casinoId) {
      state.selectedCasinoId = casinoId;
    },
  },
  actions: {
    async setCasinoId (context, input) {
      context.commit(SET_CASINO_ID, input);
    },
  }
}
